import { render, staticRenderFns } from "./WeaponGrid.vue?vue&type=template&id=19f499c6&scoped=true&"
import script from "./WeaponGrid.vue?vue&type=script&lang=ts&"
export * from "./WeaponGrid.vue?vue&type=script&lang=ts&"
import style0 from "./WeaponGrid.vue?vue&type=style&index=0&id=19f499c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f499c6",
  null
  
)

export default component.exports